<div class="login-container">
  <div class="login-card">
    <div class="login-card-isotipo">
      <img src="img/logo.png" alt="" srcset="">
    </div>
    
    <div class="p-inputgroup">
      <span (click)="goBack()" class="p-inputgroup-addon">
        <i class="pi pi-arrow-left"></i>
      </span>
      <label class="login-subtitle">Ingresa el código de verificación</label>
    </div>
    <p class="login-description">Ya casi terminamos. Ingresa el código que te enviamos por correo para recuperar tu contraseña.</p>
    <form [formGroup]="loginForm">
      <div class="input-group">
        <label class="input-label">Código</label>
        <input 
          type="text"
          formControlName="code"
          placeholder="0000"
          class="custom-input"
          [class.input-error]="(submitted || f['code'].touched) && f['code'].errors"
          maxlength="4"
        />
        <div *ngIf="(submitted || f['code'].touched) && f['code'].errors" class="error-message">
          <div *ngIf="f['code'].errors['required']">Código inválido</div>
        </div>
      </div>

      <button 
        pButton 
        type="submit" 
        class="login-button"
        [disabled]="loginForm.invalid"
        (click)="verifyCode()"
      >
        Verificar código
      </button>
      <button
        pButton
        type="button"
        class="login-button login-send"
        [disabled]="isCountdownActive || (loginForm.invalid && submitted)"
        (click)="resendCode()"
      >
        {{ isCountdownActive ? ('Reenviar código ' + countdown) : 'Reenviar código' }}
      </button>
    </form>
  </div>
  <p-toast></p-toast>
</div>